export function redirectToMobileAppStore(): void {
  if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.zellarmobile';
  } else {
    window.location.href = 'https://apps.apple.com/gb/app/cultx/id1603619411';
  }
}
